<template>
  <v-container fluid
               style="min-height: 90px; max-height: 90px; position: absolute; top: 0; z-index: 99999999 !important;"
               pa-0>
    <v-snackbar v-model="snackbar.value"
                absolute
                top
                right
                color="secondary"
                :timeout="3000"
    >{{ snackbar.text }}
    </v-snackbar>
    <v-row justify="center" align="center">
      <img src="@/assets/top_bar.svg"
           alt=""
           style="width: 100%; height: 90px; position: fixed; top: 0; left: 0;"
      >
      <v-col cols="4">
        <img src="@/assets/fitt_dark.svg" alt="Fitt" class="logo mx-5">
        <img :src="logo.url" style="max-height:50px; max-width:100px;" class="logo mb-2" v-if="logo">
      </v-col>
      <v-col cols="4"
             class="text-center text-capitalize title font-weight-thin" align-self="center" style="margin-top:-15px;">
        <transition :name="$vuetify.rtl ? 'system-header-slide-x-rtl' : 'system-header-slide-x'">
          <v-row v-if="shouldShowTitle" justify="center">
            {{ title }}
          </v-row>
        </transition>

      </v-col>

      <v-col cols="4" class="text-end">
        <v-row justify="end" no-gutters align="center" class="flex-nowrap">
          <v-col cols="auto" v-if="shouldShowLanguageChange && currentLanguage">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-chip color="secondary" small v-on="on" v-bind="attrs" class="mr-3 ml-3">{{ currentLanguage.languagename }}</v-chip>
              </template>
              <v-list class="pa-0">
                <v-list-item
                    v-for="(item) in languages"
                    :key="item.languageid"
                    :disabled="item.languageid===currentLanguage.languageid"
                    @click="changeLanguage(item.languageid)"
                >
                  <v-list-item-title>{{ item.languagename }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <transition :name="$vuetify.rtl ? 'system-header-slide-x-rtl' : 'system-header-slide-x'">
              <v-row justify="end" align="center" class="mr-5 ml-3" v-if="shouldShowProfilePic">
                <v-avatar color="secondary title"
                          style="box-shadow: 0 0 0 2px white; cursor: pointer;"
                          size="42"
                          class="mx-2"
                          v-ripple
                          @click="goToProfile()"
                >
                  <v-img :src="profilepic.thumbnail_url"></v-img>
                </v-avatar>
                <span class="title limit-length">
                    {{ name }}
                    </span>
              </v-row>
            </transition>
          </v-col>
        </v-row>
        <transition :name="$vuetify.rtl ? 'system-header-slide-x-rtl' : 'system-header-slide-x'">
          <Monitoring v-if="showMonitoring && !profilePicHidden" @exit="monitoringComplete()"
                      ref="monitoring"></Monitoring>
        </transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Monitoring from "../../components/webcam/Monitoring";
import applicationEventHub from "../../events/applicationEventHub";

export default {
  name: "SystemHeader",
  components: {
    Monitoring
  },
  props: {
    title: {
      required: true,
      type: String
    }
  },
  data: () => ({
    snackbar: {
      value: false,
      text: ''
    },
    canOpenProfile: true,
    showMonitoring: false,
    locale : ''
  }),
  computed: {
    profilePicHidden() {
      return this.$store.state.assessment.assessment.person.hide_picture;
    },
    shouldShowTitle() {
      return !this.showMonitoring;
    },
    shouldShowProfilePic() {
      return !!this.assessment && !!this.profilepic;
    },
    profilepic() {
      return this.$store.state.assessment.assessment.profilepic;
    },
    assessment() {
      return this.$store.state.assessment.assessment;
    },
    name() {
      if (!this.assessment) return '';
      return this.assessment.person.name + ' ' + this.assessment.person.surname;
    },
    logo() {
      if (!this.assessment || !this.assessment.project.client.theme.darklogo) {
        return null;
      } else {
        return this.assessment.project.client.theme.darklogo;
      }
    },
    languages() {
      if(this.$store.state.journey && this.$store.state.journey.journey && this.$store.state.assessment && this.$store.state.assessment.assessment){
        return this.$store.state.assessment.assessment.project.available_languages;
      }else{
        return [];
      }
    },
    shouldShowLanguageChange(){
      return this.languages && this.languages.length > 1 && this.$store.state.language.locale;
    },
    currentLanguage() {
      let locale = this.$store.state.language.locale;
      if(!this.languages || this.languages.length === 0){
        return null;
      }
      for(let lang of this.languages){
        if(lang.languageid===locale){
          return lang;
        }
      }
      return null;
    }
  },
  mounted() {
    this.listenForMonitoringEvents();

  },
  methods: {
    goToProfile() {
      if(this.canOpenProfile){
        this.$router.push(`/users/profile`)
      }
    },
    listenForMonitoringEvents() {
      applicationEventHub.$on('video-monitoring-start', this.startMonitoring);
      applicationEventHub.$on('video-monitoring-stop', this.stopMonitoring);

      applicationEventHub.$on('framework.question.timer.show',this.blockProfileView);
      applicationEventHub.$on('framework.question.timer.hide', this.enableProfileView);
    },
    clearMonitoringEvents() {
      applicationEventHub.$off('video-monitoring-start', this.startMonitoring);
      applicationEventHub.$off('video-monitoring-stop', this.stopMonitoring);

      applicationEventHub.$off('framework.question.timer.show',this.blockProfileView);
      applicationEventHub.$off('framework.question.timer.hide', this.enableProfileView);
    },
    blockProfileView() {
      this.canOpenProfile = false;
    },
    enableProfileView() {
      this.canOpenProfile = true;
    },
    startMonitoring() {
      this.showMonitoring = true;
    },
    stopMonitoring() {
      if (!this.$refs.monitoring) return;
      this.$refs.monitoring.stopMonitoring();
      setTimeout(() => {
        this.showMonitoring = false;
      }, 1000);
    },
    monitoringComplete() {
      this.showMonitoring = false;
    },
    changeLanguage(locale) {
      this.loading = true;
      this.$store.dispatch('assessment/updateAssessmentLanguage', locale).then(() => {
        this.navigate();
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
  },
  beforeDestroy() {
    this.clearMonitoringEvents();
  }
}
</script>

<style scoped>
.logo {
  /*padding-left: 20px;*/
  padding-top: 10px;
  max-width: 100px;
}

.limit-length {
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.system-header-slide-x-enter-active {
  animation: monitoring-slide-left .3s forwards;
}

.system-header-slide-x-leave-active {
  animation: monitoring-slide-left .3s reverse;
}

@keyframes monitoring-slide-left {
  0% {
    transform: translateY(-200px);
  }

  100% {
    transform: translateY(0);
  }
}

.system-header-slide-x-rtl-enter-active {
  animation: monitoring-slide-right .3s forwards;
}

.system-header-slide-x-rtl-leave-active {
  animation: monitoring-slide-right .3s reverse;
}

@keyframes monitoring-slide-right {
  0% {
    transform: translateY(200px);
  }

  100% {
    transform: translateY(0);
  }
}
</style>
